import { FC } from "react"

interface DropdownItemProps {
    icon: React.FC<React.SVGProps<SVGSVGElement>>
    label: string
    onClick?: () => void
}

export const DropdownItem: FC<DropdownItemProps> = ({ onClick, label, icon: Icon }) => {
    return (
        <li onClick={onClick} className="py-2 flex transition px-3 text-color-dark bg-white hover:cursor-pointer hover:bg-black/5">
            <Icon width={24} height={24} />
            <div className="ml-[6px] text-nowrap text-base">
                {label}
            </div>
        </li>
    )
}